import { render, staticRenderFns } from "./UsageSMS.vue?vue&type=template&id=0d87103d&scoped=true&"
import script from "./UsageSMS.vue?vue&type=script&lang=js&"
export * from "./UsageSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d87103d",
  null
  
)

export default component.exports